import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cached = null;
let listeners = [];

export function useSettings() {
  const [s, setS] = useState(cached);
  useEffect(() => {
    if (cached) { setS(cached); return; }
    api.get("/settings").then((r) => { cached = r.data || {}; setS(cached); listeners.forEach((l) => l(cached)); }).catch(() => {});
    listeners.push(setS);
    return () => { listeners = listeners.filter((l) => l !== setS); };
  }, []);
  return s || {};
}
